<template>
  <div>
    <page-heading-info
    title="Jefferson County Auditor's Office"
    phone="(740) 283-8511"
    courthouse="true"
    hours="8:30 - 4:30 (M-F)"
    floor="4th Floor"
    ></page-heading-info>

    <div class="row">

      <div class="col-md-6 order-1 order-md-0">
        <div class="row">
          <div class="col-12 mt-3">
            <link-box
            bg-color="dark"
            dark="true"
            icon="description"
            icon-color="light"
            title-color="light"
            title="W9 Forms"
            title-align="left"
            url="https://www.irs.gov/pub/irs-pdf/fw9.pdf?portlet=3">
            Click here to download W9 forms
            </link-box>
          </div>

          <div class="col-12 mt-3">
            <link-box
            bg-color="dark"
            dark="true"
            icon="search"
            icon-color="light"
            title-color="light"
            title="Online Dog Licensing"
            title-align="left"
            url="https://www.doglicenses.us/OH/Jefferson/">
            Purchase dog licenses here
            </link-box>
          </div>

          <div class="col-12 mt-3">
            <link-box
            bg-color="primary"
            dark="true"
            icon="table_rows"
            icon-color="light"
            title-color="light"
            title="Interesting Facts"
            title-align="left"
            route="/auditor/interesting-facts">
            Interesting facts about Jefferson County, Ohio
            </link-box>
          </div>

        </div>
      </div>

      <div class="col-md-6 mt-3 image-flex order-0 order-md-1">
        <img src="static/images/general/lake_01.jpg" alt="A lake surrounded by trees on the opposite shore." class="border-1 text-dark" />
      </div>

    </div>

    <text-box-title title="Auditor Links" class="mt-3">
      <div class="col-md-4 mt-3 complaint-box">
				<a href="/auditor/weights-measures-complaint">
				<div class="container-fluid d-flex h-100 flex-column">
					<div class="row text-center justify-content-center flex-grow-1 bg-jeff-yellow">
						<div class="col">
							<div class="mt-3 bg-dark text-jeff-yellow">
								<h4 class="pt-2">Weights &amp; Measures</h4>
								<h4 class="pb-2">Complaint Form</h4>
							</div>
							<div class="mt-3 mb-3">
								<!-- <i class="material-icons">report_problem</i> -->
								Click here to report and weights or measures in Jefferson County
								you believe to be inaccurate. 		
								<br /><br />
								Examples are: gas pumps, scales, price scanners, and firewood
							</div>
						</div>
					</div>
				</div>
				</a>
			</div>

      <div class="col-md-4 li-pad-bottom-05 mt-3">
        <ul class="list-group list-group-flush">
          <li class="list-group-item">
            <router-link to="#general-accounting">
              General Accounting
            </router-link>
          </li>
          <li class="list-group-item">
            <router-link to="#manufactured-housing">
              Manufactured Housing
            </router-link>
          </li>
          <li class="list-group-item">
            <router-link to="#homestead-exemption">
              Homestead Exemption
            </router-link>
          </li>
          <li class="list-group-item">
            <router-link to="#appraisal">
              Real Estate Appraisal and Assessment
            </router-link>
          </li>
          <li class="list-group-item">
            <router-link to="#special-assessments">
              Special Assessments
            </router-link>
          </li>
        </ul>
      </div>

      <div class="col-md-4 li-pad-bottom-05 mt-3">
        <ul class="list-group list-group-flush">
          <li class="list-group-item">
            <router-link to="#real-taxes">
              Real Estate Taxes and Rates
            </router-link>
          </li>
          <li class="list-group-item">
            <router-link to="#personal-taxes">
              Personal Property Taxes
            </router-link>
          </li>
          <li class="list-group-item">
            <router-link to="#licensing">
              Licensing
            </router-link>
          </li>
          <li class="list-group-item">
            <router-link to="#weights-measures">
              Weights &amp; Measures
            </router-link>
          </li>
          <li class="list-group-item">
            <router-link to="/auditor/board-of-revision">
              Board of Revision
            </router-link>
          </li>
          <li class="list-group-item">
            <router-link to="/employee-resources">
              Employee Resources
            </router-link>
          </li>
        </ul>
      </div>
    </text-box-title>

    <!-- auditor document downloads -->
    <text-box-title class="mt-3" title="Jefferson County Auditor Downloads">
      <note-documents note-id="30" :nullMessage="this.nullMessage" class="ml-3 mr-3 mt-3"></note-documents>
    </text-box-title>

    <!--<text-box-title class="mt-3" title="Jefferson County Annual Budget">
      <note-documents note-id="2" class="ml-3 mr-3 mt-3"></note-documents>
    </text-box-title>-->

    <text-box-title title="Jefferson County Special Assessments">
      <note-documents note-id="63" :nullMessage="this.nullMessage" class="ml-3 mr-3 mt-3"></note-documents>
    </text-box-title>

    <text-box-title title="Jefferson County 5 Year Budget Reports">
      <note-documents note-id="61" :nullMessage="this.nullMessage" class="ml-3 mr-3 mt-3"></note-documents>
    </text-box-title>

    <text-box-title title="Jefferson County Annual Financial Reports">
      <note-documents note-id="62" :nullMessage="this.nullMessage" class="ml-3 mr-3 mt-3"></note-documents>
    </text-box-title>

    <text-box-title title="Older Documents">
      <router-link class="ml-3 mr-3 mt-3" to="/archive/Auditor">Archived Auditor Documents</router-link>
    </text-box-title>

    <!-- text descriptions of auditor functions -->
    <text-box-title title="General Accounting" id="general-accounting" class="mt-3">
      <div class="col-md-6 mt-3">
        The County Auditor is the Chief Fiscal Officer in the County. It is his/her responsibility to account for the millions 
        of dollars received each year by the County and to issue warrants (checks) in payment of all County obligations. 
        These obligations include the distribution of tax dollars to the townships, villages, cities, school districts and 
        library systems as well as other county agencies. The Auditor's General Accounting Department is the overseer of all county funds.
      </div>
      <div class="col-md-6 mt-3">
        The General Accounting Department also maintains the official records of all receipts, disbursements and fund balances. 
        In addition, it is the Auditor's responsibility to serve as the paymaster for all County employees. Finally, the Auditor 
        is responsible for distributing motor vehicle license fees, gasoline taxes, estate taxes, fines, and local government funds 
        in addition to real estate, personal property, and manufactured home taxes.
      </div>
    </text-box-title>

    <text-box-title title="Manufactured Housing" id="manufactured-housing" class="mt-3">
      <div class="col-md-6 mt-3">
        Under Ohio law, it is the responsibility of owners of manufactured homes (house trailers) to register their homes with the 
        County Auditor for tax purposes. Annually, the Auditor's office assesses each manufactured home and prepares a tax list. 
        Tax bills are sent to each owner semi-annually. The house trailer tax is distributed back to the local taxing 
        districts (townships and schools) in the same manner as real estate taxes. Countywide, there are over 1,500 manufactured homes on the tax lists.
      </div>
    </text-box-title>

    <text-box-title title="Homestead Exemption" id="homestead-exemption" class="mt-3">
      <div class="col-md-6 mt-3">
        Real Estate Property Tax Rollback and Homestead Exemptions are forms of property tax relief. Every property taxpayer receives 
        the tax rollback. This law was enacted several years ago with the enactment of the state income tax. The Auditor's office also administers 
        the owner occupancy tax reduction for residential and agricultural parcels on which there is a home site occupied by the owner.
      </div>
      <div class="col-md-6 mt-3">
        The homestead exemption provides a reduction in property taxes to any senior or disabled citizen on the dwelling that is the individual's 
        principal place of residence and up to one acre of land of which an eligible individual is an owner. The reduction is equal to the taxes that 
        would otherwise be charged on up to $25,000 of the market value of an eligible taxpayer's homestead.
      </div>
    </text-box-title>

    <text-box-title title="Real Estate Appraisal and Assessment" id="appraisal" class="mt-3">
      <div class="col-md-6 mt-3">
        Jefferson County has close to 60,000 separate parcels of real property. It is the duty of the Auditor to see that every parcel of 
        land, and the buildings thereon, are fairly appraised and assessed for tax purposes. A general reappraisal is mandated by Ohio law 
        every six years with an update at the three year midpoint.
      </div>
      <div class="col-md-6 mt-3">
        The office maintains a detailed record of the appraisal on each parcel in the county. These records are open for public inspection. 
        For taxation purposes, you are assessed at 35% of the fair market value.
      </div>
    </text-box-title>

    <text-box-title title="Special Assessments" id="special-assessments" class="mt-3">
      <div class="col-md-6 mt-3">
        Special assessments are not part of your real estate tax, but are included as a separate item on the real estate tax bill. These could 
        include such items as ditch assessments or improvement levies such as street paving, curbs, lighting, sidewalks, and sewer or water lines.
      </div>
      <div class="col-md-6 mt-3">
        The Auditor is required by law to keep an account of the special assessments and to place them on the tax duplicate as separate items. 
        The money collected is returned to the city, village, township, or county office which imposed the assessment.
      </div>
    </text-box-title>

    <text-box-title title="Real Estate Taxes and Rates" id="real-taxes" class="mt-3">
      <div class="col-md-4 mt-3">
        Under Ohio Revised Code, the County Auditor cannot raise or lower property taxes. Tax rates are determined by the budgetary 
        requests of each governmental unit, as authorized by the vote of the people, and are computed in strict accordance with procedures 
        required by the Division of Tax Equalization, Ohio Department of Taxation.
      </div>
      <div class="col-md-4 mt-3">
        Annually, the Auditor prepares the general Tax List. Your tax bill is based on the tax rate multiplied by your valuation on this tax list. 
        This is your proportional share of the cost of operating your local government including schools, townships, villages, and the county.
      </div>
      <div class="col-md-4 mt-3">
        Ohio law limits the amount of taxation without vote of the people to what is known as the "10 mill limitation" ($10.00 per 1,000 of assessed valuation) 
        Any additional real estate taxes for any purpose must be voted by the county residents. Your "tax rate" is an accumulation of all these levies and bond issues.
      </div>
    </text-box-title>

    <text-box-title title="Licensing" id="licensing" class="mt-3">
      <div class="col-md-6 mt-3">
        The Auditor's office is the focal point in the county for the issuance of licenses for dogs, kennels, vendors, and cigarettes. 
        Dog licenses comprise the largest number of licenses sold. The annual dog registration is a service designed to benefit the animal, 
        owner, and community. Vendor licenses authorize businesses to sell tangible property to the public and collect sales tax, a part of 
        which is returned for use on the local level.
      </div>
    </text-box-title>

    <text-box-title title="Weights &amp; Measures" id="weights-measures" class="mt-3">
      <div class="col-md-6 mt-3">
        The Auditor is the Sealer of Weights and Measures for the entire County, thus protecting the general public from the possible loss 
        which may occur from faulty measuring devices, such as scales and pumps. The Auditor must insure that all State laws relating to weights 
        and measures are strictly enforced.
      </div>
      <div class="col-md-6 mt-3">
        Sealers perform "spot-checks" on prepackaged items to test weight of the contents. County sealers are certified by the Ohio Department of Agriculture. 
        A few cities in Ohio employ their own sealers.
      </div>
    </text-box-title>

  </div>
</template>

<script>
import PageHeadingInfo from '@/components/layout/PageHeadingInfo.vue'
import TextBoxTitle from '@/components/layout/TextBoxTitle.vue'
import LinkBox from '@/components/layout/LinkBox.vue'
import NoteDocuments from '@/components/display-utils/NoteDocuments.vue'

export default {
  components: {
    PageHeadingInfo,
    TextBoxTitle,
    LinkBox,
    NoteDocuments
  },
  data () {
    return {}
  },
  props: {
    nullMessage: {
      type: String,
      default: "No current documents available. See the archives linked below for older documents."
    }
  },
}
</script>

<style scoped>
	.complaint-box a {
		font-weight: normal;
		text-decoration: none;
		color: #37434d;
	}

	.complaint-box a:hover {
		text-decoration: underline;
	}

</style>
